import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { Collapse, Modal, Form, Input, Button, message } from 'antd';
import { DownOutline } from 'antd-mobile-icons';
import MobileComponentWrapper from '@/components/MobileComponentWrapper';
import PcComponentWrapper from '@/components/PcComponentWrapper';
import styles from './styles.module.less';
import useGetUserInfo from '@/hooks/useGetUserInfo';
import { useRouter } from 'next/router';
import { useRequest } from 'ahooks';
import {
  getSignupExplain,
  updateSignupExplain,
} from '@/services/console/signupExplain';
import { SignupExplainType } from '@/types/tipText';
import SettingsEditor from '@/components/SettingsEditor';
import ReadOnlyEditor from '@/components/SettingsEditor/readOnlyEditor';

const { Panel } = Collapse;

type TSpread = {
  signupText?: string[];
};

const Spread: React.FC<TSpread> = ({ signupText = [] }) => {
  const [isSpread, setIsSpread] = useState(true);
  const [signupExplainData, setSignupExplainData] =
    useState<SignupExplainType>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  // 鉴权
  const [isAuth, setIsAuth] = useState(false);
  const { permission } = useGetUserInfo();
  // 获取路由
  const router = useRouter();

  // 提交表单
  const handleSubmit = (values: any) => {
    // 处理提交逻辑
    const data = {
      id: signupExplainData?.id,
      certId: router.query.type,
      content: JSON.stringify(values.content),
    };
    updateSignupExplainRequest(data);
  };

  // 提交报名须知
  const { run: updateSignupExplainRequest } = useRequest(
    (data: any) => {
      return updateSignupExplain(data);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setSignupExplainData(res.data);
        setIsModalVisible(false);
        message.success({
          content: '保存成功',
        });
      },
    },
  );

  // 获取报名须知
  const { run: getSignupExplainRequest } = useRequest(
    (certId) => {
      return getSignupExplain(certId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setSignupExplainData(res);
      },
    },
  );

  useEffect(() => {
    if (router.query.type) {
      getSignupExplainRequest(router.query.type);
    }
  }, [router.query.type]);

  useEffect(() => {
    if (permission?.superAdmin || permission?.manageExamDescribe) {
      setIsAuth(true);
    }
  }, [permission]);
  return (
    <div className={styles.spread_wrapper}>
      <Collapse
        defaultActiveKey="1"
        ghost
        expandIconPosition="right"
        onChange={() => {
          setIsSpread(!isSpread);
        }}
      >
        <Panel
          showArrow={false}
          header={
            <div className={styles.title}>
              <span>报名须知</span>
              <MobileComponentWrapper>
                <DownOutline
                  className={cx(styles.icon, isSpread && styles.icon_rotate)}
                />
              </MobileComponentWrapper>

              <div className="flex_1" style={{ gap: 16 }}>
                {isAuth && (
                  <span
                    className={styles.icon}
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsModalVisible(true);
                    }}
                  >
                    编辑
                  </span>
                )}
                <PcComponentWrapper>
                  <span className={styles.icon}>
                    {isSpread ? '收起' : '展开'}
                  </span>
                </PcComponentWrapper>
              </div>
            </div>
          }
          key="1"
        >
          <div style={{ paddingTop: 16 }}>
            <>
              {signupExplainData?.content ? (
                <ReadOnlyEditor
                  content={signupExplainData?.content}
                  className="com_edit_new"
                  style={{ background: 'none' }}
                />
              ) : (
                signupText.map((item) => {
                  return (
                    <h3
                      className={styles.body_item}
                      key={item}
                      dangerouslySetInnerHTML={{ __html: item }}
                    />
                  );
                })
              )}
            </>
          </div>
        </Panel>
      </Collapse>

      <div>
        <Modal
          title={null}
          wrapClassName={styles.signup_explain_modal}
          keyboard={false}
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
          width={'100%'}
          bodyStyle={{
            padding: 0,
            height: '100%',
          }}
          style={{ height: '100%' }}
        >
          <div>
            <Form
              form={form}
              onFinish={handleSubmit}
              initialValues={{ content: signupExplainData?.content }}
              layout="vertical"
            >
              <Form.Item
                label=""
                name="content"
                rules={[{ required: true, message: '内容不能为空' }]}
              >
                <SettingsEditor
                  style={{ height: 'calc(100vh - 100px)' }}
                  content={signupExplainData?.content}
                  className="com_edit_new_not_full"
                />
              </Form.Item>
              <div
                style={{
                  textAlign: 'right',
                  marginTop: 16,
                  borderTop: '1px solid #eee',
                  padding: '16px 24px',
                }}
              >
                <Button
                  style={{ marginRight: 12 }}
                  onClick={() => {
                    setIsModalVisible(false);
                  }}
                >
                  退出编辑
                </Button>
                <Button type="primary" htmlType="submit">
                  保存并发布
                </Button>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    </div>
  );
};
export default Spread;
